import FormDrawer from 'components/__new/common/form-drawer'
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { toast } from 'react-toastify'


const TransferDestinationModal = ({isOpen, setIsOpen, toggleEarnipayTransferType, toggleBankTransferType, transferTypes, transferDestination, setTransferDestination, setSelectedSourceAccount}) => {
    
    const onProceed = () => {
        if(transferDestination === "") {
            toast.error("Please select a transfer destination")
        } else {
            
            if(transferDestination === "earnipay") {
                toggleEarnipayTransferType();
            } else if (transferDestination === "bank") {
                toggleBankTransferType();
            }
            setSelectedSourceAccount(null);
            setIsOpen(false);
        }
    }
    
    return (
        <FormDrawer display="center" size="xl" isOpen={isOpen} setIsOpen={() => {}}>
            <div className='p-7'>
                
                <div className='pb-2 mb-2 border-b'>
                    <div className="flex items-center justify-between">
                        <div className="text-xl font-bold">
                            Where are you transferring to?
                        </div>
                        
                        <div onClick={() => setIsOpen(false)} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                            <IconTimes width={30} />
                        </div>
                    </div>
                    
                    <div className="pt-3">
                        Choose where you want to send money
                    </div>
                </div>
                
                
                <div className="flex items-center justify-center lg:justify-between flex-wrap lg:flex-nowrap py-5 w-full">
                    {transferTypes.map(({title, subtitle, Icon, value}) => {
                        const isActive = transferDestination === value;
                        
                        return (
                            <div
                                key={title}
                                onClick={() => setTransferDestination(value)}
                                className={`w-full lg:w-[48%] cursor-pointer flex items-center justify-center mb-5 lg:mb-0 flex-col p-4 pt-14 rounded-xl border transition-colors duration-300 relative ${isActive ? "border-ep-primary-600 bg-ep-primary-400 bg-opacity-[5%]" : ""}`}>
                                
                                <div className={`absolute top-2 right-2 transition-opacity duration-300 ${isActive ? "opacity-100" : "opacity-0"}`}>
                                    <IconCheckCircle />
                                </div>
                                    
                                <Icon />
                                <div className="font-semibold mt-7 mb-2">{title}</div>
                                <div className='text-sm text-center'>{subtitle}</div>
                            </div>
                        )
                    })}
                </div>
                
                
                <div className="flex items-center justify-end pt-4">
                    <button disabled={!transferDestination} type="button" onClick={onProceed} className="btn btn-ep-primary">
                        Continue
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}

export default TransferDestinationModal